import type { SVGProps } from 'react';
const SvgAutoAwesomeMotion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#auto_awesome_motion_svg__a)">
      <path
        fill="currentColor"
        d="M14 2H4a2 2 0 0 0-2 2v10h2V4h10V2Zm4 4H8a2 2 0 0 0-2 2v10h2V8h10V6Zm2 4h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2Z"
      />
    </g>
    <defs>
      <clipPath id="auto_awesome_motion_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAutoAwesomeMotion;
